exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-grey-onfly[data-v-ad715a6e]{color:#54667a!important}.page-title[data-v-ad715a6e]{font-weight:700;text-transform:uppercase;font-size:24px}.card-box[data-v-ad715a6e]{box-shadow:0 4px 8px rgba(0,0,0,.15);border-radius:16px;padding:48px 32px;border:1px solid #d3d3d3;display:flex;flex-direction:column;gap:16px;background-color:#fff}", ""]);

// exports
